const namespace = '[Report Card]';

export const REPORT_CARD_GET = `${namespace} REPORT CARD GET`;
export const REPORT_CARD_GET_SKILLS = `${namespace} REPORT CARD GET SKILLS`;
export const REPORT_CARD_SKILLS_SYNC_PROGRESS = `${namespace} REPORT CARD SKILLS SYNC PROGRESS`;
